module.exports = __webpack_public_path__ + "static/media/Vector.00c6070c.svg";